import { useEffect, useRef } from 'react'

interface UseAutoSaveProps {
    saveFn: () => void
    intervalMs?: number
}

export function useAutoSave({ saveFn, intervalMs = 2000 }: UseAutoSaveProps) {
    const saveFnRef = useRef(saveFn)

    useEffect(() => {
        saveFnRef.current = saveFn
    }, [saveFn])

    useEffect(() => {
        const intervalId = setInterval(() => {
            saveFnRef.current()
        }, intervalMs)
        return () => clearInterval(intervalId)
    }, [intervalMs])
}
